/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import { Edit, InfoRound, List } from '@rsuite/icons';

import { Table, FlexboxGrid, SelectPicker, IconButton, Toggle } from 'rsuite';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Container } from '~/styles/tabela1';
import api from '~/services/api';
import SearchInputTable from '~/components/SearchInputTable';
import { FiltroExperiencias } from '~/components/FiltroExperiencias';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import SelectState from '~/components/SelectState';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { TabelaPaginacao } from '~/components/TabelaPaginacao';
import { MdOutlinePeopleOutline, MdWorkOutline } from 'react-icons/md';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { FaRegStar } from 'react-icons/fa';
import EditarProfissional from '../../Profissionais/EditarProfissional';
import DetalhesCarteiraDialog from '../CarteiraProfissionais/components/DetalhesCarteiraDialog';
import ModalNotificacaoEmergencia from './components/ModalNotificacaoEmergencia';
import ModalPedidosDisponiveis from './components/ModalPedidosDisponiveis';
import { ToggleContacto } from './styles';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function RelatorioProfissionaisEmergencia() {
  const [relatorios, setRelatorios] = useState({
    lista: [],
    quantidade: 0,
  });
  const [orderBy, setOrderBy] = useState();
  const [experiencias, setExperiencias] = useState([]);
  const [experienciaSelecionada, setExperienciaSelecionada] = useState();
  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoSelecionado, setTreinamentoSelecionado] = useState();
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [ufSelecionado, setUfSelecionado] = useState();
  const [atributoSelecionado, setAtributoSelecioando] = useState('nome');
  const [textodigitado, setTextoDigitado] = useState();
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [exibirDetalhesDialog, setExibirDetalhesDialog] = useState({
    exibir: false,
  });
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);
  const [filtroData, setFiltroData] = useState();
  const [filtrarContactado, setFiltrarContactado] = useState();
  const [exibirModalPedidos, setExibirModalPedidos] = useState({
    exibir: false,
    profissional: null,
  });
  const atributosFiltro = [
    {
      label: 'Nome',
      value: 'nome',
    },
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Cpf',
      value: 'cpf_cnpj',
    },
    {
      label: 'Cidade',
      value: 'cidade',
    },
  ];
  const buscarRelatorios = useCallback(async () => {
    setCarregando(true);
    try {
      const resposta = await api.get('relatorios/profissionais-emergencia', {
        params: {
          pagina,
          [atributoSelecionado]: textodigitado,
          estado: estadoSelecionado,
          experiencias: experienciaSelecionada,
          treinamentos: treinamentoSelecionado,
          orderBy,
          contactado: filtrarContactado,
        },
      });

      const lista = resposta.data.lista.map((p) => ({
        ...p,
        uf: p.uf,
        estado: p.endereco.bairro.cidade.estado.uf,
        cidade: p.endereco.bairro.cidade.cidade,
        created_at: moment(p.created_at).format('DD/MM/YYYY | HH:mm'),
        contactado: p.contactado,
      }));

      setRelatorios({
        quantidade: lista.length > 0 ? lista[0].full_count : 0,
        lista,
      });
      if (relatorios.quantidade === 0) setPagina(1);

      const experiencias1 = await api.get('profissao');
      setExperiencias(experiencias1.data);
      const treinamentos1 = await api.get('treinamento');
      setTreinamentos(treinamentos1.data);
    } catch (e) {
      toast.error(e.message);
    }

    setCarregando(false);
  }, [
    pagina,
    atributoSelecionado,
    textodigitado,
    estadoSelecionado,
    experienciaSelecionada,
    treinamentoSelecionado,
    orderBy,
    setPagina,
    relatorios.quantidade,
    filtrarContactado,
  ]);

  useEffect(() => {
    buscarRelatorios();
  }, [buscarRelatorios]);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  function fecharEditarProfissional() {
    buscarRelatorios();
    setShowEditarProfissional(false);
  }

  async function alteracaoContactado(rowData) {
    try {
      await api.patch(`relatorios/profissionais-emergencia/${rowData.id}`, {
        contactado: !rowData.contactado,
      });
      toast.success('Alterado com sucesso');
      buscarRelatorios();
    } catch (e) {
      toast.error(e.message);
    }
  }

  const CelulaAcaoContactado = ({ rowData, ...props }) => (
    <Cell {...props}>
      <ToggleContacto>
        <Toggle
          checkedChildren="Sim"
          unCheckedChildren="Não"
          defaultChecked={rowData.contactado}
          onChange={() => alteracaoContactado(rowData)}
        />
      </ToggleContacto>
    </Cell>
  );

  const activeFilters = React.useMemo(() => {
    const filters = [];
    if (textodigitado) {
      filters.push({
        key: atributoSelecionado,
        label: `${atributoSelecionado}: ${textodigitado}`,
        clear: () => setTextoDigitado(undefined),
      });
    }
    if (estadoSelecionado) {
      filters.push({
        key: 'Estado',
        label: `Estado: ${ufSelecionado || estadoSelecionado}`,
        clear: () => {
          setEstadoSelecionado(undefined);
          setUfSelecionado(undefined);
        },
      });
    }
    if (experienciaSelecionada) {
      filters.push({
        key: 'Experiência',
        label: `${experienciaSelecionada.length} experiência(s)`,
        clear: () => setExperienciaSelecionada(undefined),
      });
    }
    if (treinamentoSelecionado) {
      filters.push({
        key: 'Treinamento',
        label: `${treinamentoSelecionado.length} treinamento(s)`,
        clear: () => setTreinamentoSelecionado(undefined),
      });
    }
    if (filtrarContactado) {
      filters.push({
        key: 'Contactado',
        label: `Contactado: ${filtrarContactado === 'true' ? 'Sim' : 'Não'}`,
        clear: () => setFiltrarContactado(undefined),
      });
    }
    return filters;
  }, [
    textodigitado,
    atributoSelecionado,
    estadoSelecionado,
    experienciaSelecionada,
    treinamentoSelecionado,
    filtrarContactado,
  ]);

  return (
    <Container>
      <PageHeader
        title="Disponíveis para Emergência"
        subtitle="Aqui você pode visualizar os profissionais disponíveis para emergência."
      />
      {/* <h2>Disponíveis para Emergência</h2> */}
      <MetricsCards
        items={[
          {
            title: 'Total de Profissionais',
            value: relatorios.quantidade,
            icon: <MdOutlinePeopleOutline size='30px' />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Perfil Completo',
            value: '-',
            icon: <IoMdCheckmarkCircleOutline size='30px' />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Trabalharam',
            value: '-',
            icon: <MdWorkOutline size='30px' />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Interessados',
            value: '-',
            icon: <FaRegStar size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />

      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable setTextoDigitado={setTextoDigitado} />

            <SelectPicker
              appearance="default"
              style={{ marginLeft: '-5px' }}
              searchable={false}
              data={atributosFiltro}
              value={atributoSelecionado}
              cleanable={false}
              onChange={(value) => setAtributoSelecioando(value)}
            />
          </>
        }
      >

        <SelectState
          selectedState={estadoSelecionado}
          setSelectedStates={setEstadoSelecionado}
          setUfSelecionado={setUfSelecionado}
        // marginRight
        />
        <FiltroExperiencias
          style={{ width: 224 }}
          appearance="default"
          data={experiencias.map((profissao) => ({
            label: profissao.profissao,
            value: profissao.id,
          }))}
          value={experienciaSelecionada}
          onChange={(value) => setExperienciaSelecionada(value)}
        />
        <FiltroTreinamentos
          appearance="default"
          style={{ width: 224 }}
          searchable={false}
          data={treinamentos.map((treinamento) => ({
            label: treinamento.treinamento,
            value: treinamento.id,
          }))}
          value={treinamentoSelecionado}
          onChange={(value) => setTreinamentoSelecionado(value)}
        />
        <SelectPicker
          name="contactado"
          appearance="default"
          searchable={false}
          placeholder="Contactado"
          data={[
            { label: 'Sim', value: 'true' },
            { label: 'Não', value: 'false' },
          ]}
          value={filtrarContactado}
          // cleanable={false}
          onChange={setFiltrarContactado}
        />

        <ModalNotificacaoEmergencia
          atributoSelecionado={atributoSelecionado}
          textodigitado={textodigitado}
          estadoSelecionado={estadoSelecionado}
          experienciaSelecionada={experienciaSelecionada}
          treinamentoSelecionado={treinamentoSelecionado}
        />
      </AdvancedFilters>
      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={relatorios.lista}
          quantidade={relatorios.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >
          <Column resizable width={130}>
            <HeaderCell>
              <TableHeaderTooltip label='Ações' tooltip='Ações' />
            </HeaderCell>
            <Cell dataKey="id" style={{ padding: '5px' }}>
              {(rowData) => (
                <>
                  <IconButton
                    title="Detalhes"
                    appearance="subtle"
                    onClick={() => {
                      setExibirDetalhesDialog({
                        exibir: true,
                        id_profissional: rowData.id,
                      });
                    }}
                    icon={<InfoRound />}
                  />
                  <IconButton
                    title="Editar"
                    appearance="subtle"
                    onClick={() => {
                      abrirEditarProfissional(rowData);
                    }}
                    icon={<Edit />}
                  />
                  <IconButton
                    title="Pedidos Disponíveis"
                    appearance="subtle"
                    onClick={() => {
                      setExibirModalPedidos({
                        exibir: true,
                        profissional: rowData,
                      });
                    }}
                    icon={<List />}
                  />
                </>
              )}
            </Cell>
          </Column>
          <Column resizable width={250} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Nome' tooltip='Nome' />
            </HeaderCell>
            <Cell dataKey="nome" />
          </Column>
          <Column resizable width={250} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Email' tooltip='Email' />
            </HeaderCell>
            <Cell dataKey="email" />
          </Column>
          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Telefone' tooltip='Telefone' />
            </HeaderCell>
            <Cell dataKey="telefone1" />
          </Column>
          <Column resizable width={90}>
            <HeaderCell>
              <TableHeaderTooltip label='Início' tooltip='Início' />
            </HeaderCell>
            <Cell dataKey="hora_inicio" />
          </Column>
          <Column resizable width={90}>
            <HeaderCell>
              <TableHeaderTooltip label='Fim' tooltip='Fim' />
            </HeaderCell>
            <Cell dataKey="hora_fim" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cidade' tooltip='Cidade' />
            </HeaderCell>
            <Cell dataKey="cidade" />
          </Column>
          <Column resizable width={90} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Estado' tooltip='Estado' />
            </HeaderCell>
            <Cell dataKey="uf" />
          </Column>
          <Column resizable width={180} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Data e Hora' tooltip='Data e Hora' />
            </HeaderCell>
            <Cell dataKey="created_at" />
          </Column>
          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Contactado' tooltip='Contactado' />
            </HeaderCell>
            <CelulaAcaoContactado dataKey="contactado" />
          </Column>
        </TablePagination>
      </FlexboxGrid>

      <DetalhesCarteiraDialog
        exibir={exibirDetalhesDialog.exibir}
        id_profissional={exibirDetalhesDialog.id_profissional}
        datas={filtroData}
        onFechar={() => setExibirDetalhesDialog({ exibir: false })}
      />
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando.id}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        fecharEditarProfissional={fecharEditarProfissional}
        atualizarLista={buscarRelatorios}
      />
      <ModalPedidosDisponiveis
        exibir={exibirModalPedidos.exibir}
        profissional={exibirModalPedidos.profissional}
        onFechar={() =>
          setExibirModalPedidos({ exibir: false, profissional: null })
        }
      />
    </Container>
  );
}

export default RelatorioProfissionaisEmergencia;
